/* @generated from adl module kachemedia.specsheet.campaigns */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_db from './../../common/db';
import * as common_strings from './../../common/strings';
import * as kachemedia_specsheet_common from './common';
import * as kachemedia_specsheet_db from './db';
import * as kachemedia_specsheet_orgworkspace from './orgworkspace';
import * as kachemedia_specsheet_users from './users';

export interface CampaignVersionInfo {
  campaignVersion: kachemedia_specsheet_db.CampaignVersion;
  /**
   * The name of the user who published the version, if the version has been published.
   */
  userPublished: (common_strings.StringNE|null);
}

export function makeCampaignVersionInfo(
  input: {
    campaignVersion: kachemedia_specsheet_db.CampaignVersion,
    userPublished: (common_strings.StringNE|null),
  }
): CampaignVersionInfo {
  return {
    campaignVersion: input.campaignVersion,
    userPublished: input.userPublished,
  };
}

const CampaignVersionInfo_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.campaigns","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"campaignVersion","default":{"kind":"nothing"},"name":"campaignVersion","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"CampaignVersion"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The name of the user who published the version, if the version has been published.\n"}],"serializedName":"userPublished","default":{"kind":"nothing"},"name":"userPublished","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}}]}},"name":"CampaignVersionInfo","version":{"kind":"nothing"}}};

export const snCampaignVersionInfo: ADL.ScopedName = {moduleName:"kachemedia.specsheet.campaigns", name:"CampaignVersionInfo"};

export function texprCampaignVersionInfo(): ADL.ATypeExpr<CampaignVersionInfo> {
  return {value : {typeRef : {kind: "reference", value : snCampaignVersionInfo}, parameters : []}};
}

/**
 * Frontend view of a campaign, with its creator user profile
 */
export interface CampaignView {
  /**
   * Workspace that this campaign belongs to
   */
  workspace: kachemedia_specsheet_users.WorkspaceView;
  /**
   * Organisation that this campaign belongs to
   */
  organisation: kachemedia_specsheet_orgworkspace.OrganisationView;
  /**
   * Campaign Id
   */
  campaignId: common_db.DbKey<kachemedia_specsheet_db.Campaign>;
  /**
   * Campaign title
   */
  title: common_strings.StringNE;
  /**
   * Campaign summary
   */
  summary: common_strings.StringNE;
  /**
   * Campaign status
   */
  status: kachemedia_specsheet_db.CampaignStatus;
  /**
   * Live date
   */
  liveDate: common.LocalDate;
  /**
   * End (of being live) date
   */
  endDate: (common.LocalDate|null);
  /**
   * Userprofile of creator
   */
  createdBy: kachemedia_specsheet_users.UserProfile;
  /**
   * Instant of campaign creation
   */
  creationDate: common.Instant;
  /**
   * Client of the campaign
   */
  client: ClientView;
  /**
   * Starred
   */
  starred: boolean;
  /**
   * Last updated
   */
  lastUpdated: common.Instant;
  /**
   * Job number
   */
  jobNumber: string;
  /**
   * Latest (current) version number
   */
  version: kachemedia_specsheet_db.Version;
  /**
   * Set of external campaign-claims
   */
  extCampaignClaims: ExtCampaignClaimUnion[];
  /**
   * Assigned users
   */
  assignedUsers: kachemedia_specsheet_users.UserProfile[];
  assignedUserGroups: common_db.DbKey<kachemedia_specsheet_db.UserGroup>[];
  /**
   * Free text metadata
   */
  notes: kachemedia_specsheet_common.WysiwygDescendant[];
  /**
   * Documents/attachments urls
   */
  documents: kachemedia_specsheet_common.UrlResource[];
}

export function makeCampaignView(
  input: {
    workspace: kachemedia_specsheet_users.WorkspaceView,
    organisation: kachemedia_specsheet_orgworkspace.OrganisationView,
    campaignId: common_db.DbKey<kachemedia_specsheet_db.Campaign>,
    title: common_strings.StringNE,
    summary: common_strings.StringNE,
    status: kachemedia_specsheet_db.CampaignStatus,
    liveDate: common.LocalDate,
    endDate: (common.LocalDate|null),
    createdBy: kachemedia_specsheet_users.UserProfile,
    creationDate: common.Instant,
    client: ClientView,
    starred: boolean,
    lastUpdated: common.Instant,
    jobNumber: string,
    version: kachemedia_specsheet_db.Version,
    extCampaignClaims?: ExtCampaignClaimUnion[],
    assignedUsers?: kachemedia_specsheet_users.UserProfile[],
    assignedUserGroups?: common_db.DbKey<kachemedia_specsheet_db.UserGroup>[],
    notes?: kachemedia_specsheet_common.WysiwygDescendant[],
    documents?: kachemedia_specsheet_common.UrlResource[],
  }
): CampaignView {
  return {
    workspace: input.workspace,
    organisation: input.organisation,
    campaignId: input.campaignId,
    title: input.title,
    summary: input.summary,
    status: input.status,
    liveDate: input.liveDate,
    endDate: input.endDate,
    createdBy: input.createdBy,
    creationDate: input.creationDate,
    client: input.client,
    starred: input.starred,
    lastUpdated: input.lastUpdated,
    jobNumber: input.jobNumber,
    version: input.version,
    extCampaignClaims: input.extCampaignClaims === undefined ? [] : input.extCampaignClaims,
    assignedUsers: input.assignedUsers === undefined ? [] : input.assignedUsers,
    assignedUserGroups: input.assignedUserGroups === undefined ? [] : input.assignedUserGroups,
    notes: input.notes === undefined ? [] : input.notes,
    documents: input.documents === undefined ? [] : input.documents,
  };
}

const CampaignView_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.campaigns","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Frontend view of a campaign, with its creator user profile\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Workspace that this campaign belongs to\n"}],"serializedName":"workspace","default":{"kind":"nothing"},"name":"workspace","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.users","name":"WorkspaceView"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Organisation that this campaign belongs to\n"}],"serializedName":"organisation","default":{"kind":"nothing"},"name":"organisation","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.orgworkspace","name":"OrganisationView"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Campaign Id\n"}],"serializedName":"campaignId","default":{"kind":"nothing"},"name":"campaignId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Campaign"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Campaign title\n"}],"serializedName":"title","default":{"kind":"nothing"},"name":"title","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Campaign summary\n"}],"serializedName":"summary","default":{"kind":"nothing"},"name":"summary","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Campaign status\n"}],"serializedName":"status","default":{"kind":"nothing"},"name":"status","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"CampaignStatus"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Live date\n"}],"serializedName":"liveDate","default":{"kind":"nothing"},"name":"liveDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"End (of being live) date\n"}],"serializedName":"endDate","default":{"kind":"nothing"},"name":"endDate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Userprofile of creator\n"}],"serializedName":"createdBy","default":{"kind":"nothing"},"name":"createdBy","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.users","name":"UserProfile"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Instant of campaign creation\n"}],"serializedName":"creationDate","default":{"kind":"nothing"},"name":"creationDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Client of the campaign\n"}],"serializedName":"client","default":{"kind":"nothing"},"name":"client","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.campaigns","name":"ClientView"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Starred\n"}],"serializedName":"starred","default":{"kind":"nothing"},"name":"starred","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Last updated\n"}],"serializedName":"lastUpdated","default":{"kind":"nothing"},"name":"lastUpdated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Job number\n"}],"serializedName":"jobNumber","default":{"kind":"nothing"},"name":"jobNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Latest (current) version number\n"}],"serializedName":"version","default":{"kind":"nothing"},"name":"version","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Version"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Set of external campaign-claims\n"}],"serializedName":"extCampaignClaims","default":{"kind":"just","value":[]},"name":"extCampaignClaims","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.campaigns","name":"ExtCampaignClaimUnion"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Assigned users\n"}],"serializedName":"assignedUsers","default":{"kind":"just","value":[]},"name":"assignedUsers","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.users","name":"UserProfile"}},"parameters":[]}]}},{"annotations":[],"serializedName":"assignedUserGroups","default":{"kind":"just","value":[]},"name":"assignedUserGroups","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"UserGroup"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Free text metadata\n"}],"serializedName":"notes","default":{"kind":"just","value":[]},"name":"notes","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.common","name":"WysiwygDescendant"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Documents/attachments urls\n"}],"serializedName":"documents","default":{"kind":"just","value":[]},"name":"documents","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.common","name":"UrlResource"}},"parameters":[]}]}}]}},"name":"CampaignView","version":{"kind":"nothing"}}};

export const snCampaignView: ADL.ScopedName = {moduleName:"kachemedia.specsheet.campaigns", name:"CampaignView"};

export function texprCampaignView(): ADL.ATypeExpr<CampaignView> {
  return {value : {typeRef : {kind: "reference", value : snCampaignView}, parameters : []}};
}

/**
 * Campaign information
 */
export interface CampaignInfo {
  status: CampaignFrontendStatus;
}

export function makeCampaignInfo(
  input: {
    status: CampaignFrontendStatus,
  }
): CampaignInfo {
  return {
    status: input.status,
  };
}

const CampaignInfo_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.campaigns","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Campaign information\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"status","default":{"kind":"nothing"},"name":"status","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.campaigns","name":"CampaignFrontendStatus"}},"parameters":[]}}]}},"name":"CampaignInfo","version":{"kind":"nothing"}}};

export const snCampaignInfo: ADL.ScopedName = {moduleName:"kachemedia.specsheet.campaigns", name:"CampaignInfo"};

export function texprCampaignInfo(): ADL.ATypeExpr<CampaignInfo> {
  return {value : {typeRef : {kind: "reference", value : snCampaignInfo}, parameters : []}};
}

export enum CampaignFrontendStatus {
  created,
  addedPlacements,
}

const CampaignFrontendStatus_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.campaigns","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Frontend creation/edition status of a campaign\n"}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The campaign has been created\n"}],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Some placements have been added to the campaign\n"}],"serializedName":"addedPlacements","default":{"kind":"nothing"},"name":"addedPlacements","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"CampaignFrontendStatus","version":{"kind":"nothing"}}};

export const snCampaignFrontendStatus: ADL.ScopedName = {moduleName:"kachemedia.specsheet.campaigns", name:"CampaignFrontendStatus"};

export function texprCampaignFrontendStatus(): ADL.ATypeExpr<CampaignFrontendStatus> {
  return {value : {typeRef : {kind: "reference", value : snCampaignFrontendStatus}, parameters : []}};
}

/**
 * Frontend view of a client
 */
export interface ClientView {
  /**
   * Client id
   */
  clientId: common_db.DbKey<kachemedia_specsheet_db.Client>;
  /**
   * Client name
   */
  name: common_strings.StringNE;
  /**
   * Client logo
   */
  logo: kachemedia_specsheet_common.Url;
  workspaceId: common_db.DbKey<kachemedia_specsheet_db.Workspace>;
}

export function makeClientView(
  input: {
    clientId: common_db.DbKey<kachemedia_specsheet_db.Client>,
    name: common_strings.StringNE,
    logo: kachemedia_specsheet_common.Url,
    workspaceId: common_db.DbKey<kachemedia_specsheet_db.Workspace>,
  }
): ClientView {
  return {
    clientId: input.clientId,
    name: input.name,
    logo: input.logo,
    workspaceId: input.workspaceId,
  };
}

const ClientView_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.campaigns","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Frontend view of a client\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Client id\n"}],"serializedName":"clientId","default":{"kind":"nothing"},"name":"clientId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Client"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Client name\n"}],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Client logo\n"}],"serializedName":"logo","default":{"kind":"nothing"},"name":"logo","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.common","name":"Url"}},"parameters":[]}},{"annotations":[],"serializedName":"workspaceId","default":{"kind":"nothing"},"name":"workspaceId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Workspace"}},"parameters":[]}]}}]}},"name":"ClientView","version":{"kind":"nothing"}}};

export const snClientView: ADL.ScopedName = {moduleName:"kachemedia.specsheet.campaigns", name:"ClientView"};

export function texprClientView(): ADL.ATypeExpr<ClientView> {
  return {value : {typeRef : {kind: "reference", value : snClientView}, parameters : []}};
}

/**
 * Frontend view of a placement
 */
export interface PlacementView {
  /**
   * Placement
   */
  placement: common_db.WithDbId<kachemedia_specsheet_db.Placement>;
  /**
   * Publisher
   */
  publisher: common_db.WithDbId<kachemedia_specsheet_db.Publisher>;
  /**
   * Publications
   */
  validPublications: common_db.WithDbId<kachemedia_specsheet_db.Publication>[];
}

export function makePlacementView(
  input: {
    placement: common_db.WithDbId<kachemedia_specsheet_db.Placement>,
    publisher: common_db.WithDbId<kachemedia_specsheet_db.Publisher>,
    validPublications?: common_db.WithDbId<kachemedia_specsheet_db.Publication>[],
  }
): PlacementView {
  return {
    placement: input.placement,
    publisher: input.publisher,
    validPublications: input.validPublications === undefined ? [] : input.validPublications,
  };
}

const PlacementView_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.campaigns","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Frontend view of a placement\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Placement\n"}],"serializedName":"placement","default":{"kind":"nothing"},"name":"placement","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Placement"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Publisher\n"}],"serializedName":"publisher","default":{"kind":"nothing"},"name":"publisher","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Publisher"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Publications\n"}],"serializedName":"validPublications","default":{"kind":"just","value":[]},"name":"validPublications","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Publication"}},"parameters":[]}]}]}}]}},"name":"PlacementView","version":{"kind":"nothing"}}};

export const snPlacementView: ADL.ScopedName = {moduleName:"kachemedia.specsheet.campaigns", name:"PlacementView"};

export function texprPlacementView(): ADL.ATypeExpr<PlacementView> {
  return {value : {typeRef : {kind: "reference", value : snPlacementView}, parameters : []}};
}

export interface PlacementViewPartial {
  publisher: common_db.WithDbId<kachemedia_specsheet_db.Publisher>;
  placement: common_db.WithDbId<kachemedia_specsheet_db.Placement>;
  validPublication: (common_db.WithDbId<kachemedia_specsheet_db.Publication>|null);
}

export function makePlacementViewPartial(
  input: {
    publisher: common_db.WithDbId<kachemedia_specsheet_db.Publisher>,
    placement: common_db.WithDbId<kachemedia_specsheet_db.Placement>,
    validPublication?: (common_db.WithDbId<kachemedia_specsheet_db.Publication>|null),
  }
): PlacementViewPartial {
  return {
    publisher: input.publisher,
    placement: input.placement,
    validPublication: input.validPublication === undefined ? null : input.validPublication,
  };
}

const PlacementViewPartial_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.campaigns","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"publisher","default":{"kind":"nothing"},"name":"publisher","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Publisher"}},"parameters":[]}]}},{"annotations":[],"serializedName":"placement","default":{"kind":"nothing"},"name":"placement","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Placement"}},"parameters":[]}]}},{"annotations":[],"serializedName":"validPublication","default":{"kind":"just","value":null},"name":"validPublication","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Publication"}},"parameters":[]}]}]}}]}},"name":"PlacementViewPartial","version":{"kind":"nothing"}}};

export const snPlacementViewPartial: ADL.ScopedName = {moduleName:"kachemedia.specsheet.campaigns", name:"PlacementViewPartial"};

export function texprPlacementViewPartial(): ADL.ATypeExpr<PlacementViewPartial> {
  return {value : {typeRef : {kind: "reference", value : snPlacementViewPartial}, parameters : []}};
}

export interface BookingViewBasic {
  bookingDetails: common_db.WithDbId<kachemedia_specsheet_db.Booking>;
  /**
   * Publisher
   */
  publisher: common_db.WithDbId<kachemedia_specsheet_db.Publisher>;
  /**
   * Placement
   */
  placement: common_db.WithDbId<kachemedia_specsheet_db.Placement>;
  /**
   * Author - user of missing placement for linked with current booking
   */
  placementAuthorUserName: (common_strings.StringNE|null);
  /**
   * If author is from the same organisation as querying user - allow linked placement update
   */
  isPlacementEditable: boolean;
}

export function makeBookingViewBasic(
  input: {
    bookingDetails: common_db.WithDbId<kachemedia_specsheet_db.Booking>,
    publisher: common_db.WithDbId<kachemedia_specsheet_db.Publisher>,
    placement: common_db.WithDbId<kachemedia_specsheet_db.Placement>,
    placementAuthorUserName?: (common_strings.StringNE|null),
    isPlacementEditable: boolean,
  }
): BookingViewBasic {
  return {
    bookingDetails: input.bookingDetails,
    publisher: input.publisher,
    placement: input.placement,
    placementAuthorUserName: input.placementAuthorUserName === undefined ? null : input.placementAuthorUserName,
    isPlacementEditable: input.isPlacementEditable,
  };
}

const BookingViewBasic_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.campaigns","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"bookingDetails","default":{"kind":"nothing"},"name":"bookingDetails","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Booking"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Publisher\n"}],"serializedName":"publisher","default":{"kind":"nothing"},"name":"publisher","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Publisher"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Placement\n"}],"serializedName":"placement","default":{"kind":"nothing"},"name":"placement","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Placement"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Author - user of missing placement for linked with current booking\n"}],"serializedName":"placementAuthorUserName","default":{"kind":"just","value":null},"name":"placementAuthorUserName","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"If author is from the same organisation as querying user - allow linked placement update\n"}],"serializedName":"isPlacementEditable","default":{"kind":"nothing"},"name":"isPlacementEditable","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"BookingViewBasic","version":{"kind":"nothing"}}};

export const snBookingViewBasic: ADL.ScopedName = {moduleName:"kachemedia.specsheet.campaigns", name:"BookingViewBasic"};

export function texprBookingViewBasic(): ADL.ATypeExpr<BookingViewBasic> {
  return {value : {typeRef : {kind: "reference", value : snBookingViewBasic}, parameters : []}};
}

/**
 * View of a placement from a campaign
 */
export interface BookingView {
  bookingDetails: common_db.WithDbId<kachemedia_specsheet_db.Booking>;
  /**
   * Publisher
   */
  publisher: common_db.WithDbId<kachemedia_specsheet_db.Publisher>;
  /**
   * Placement
   */
  placement: common_db.WithDbId<kachemedia_specsheet_db.Placement>;
  /**
   * Values for parent groups (unpacked from QueryBookingsSuccess.bookingGroups on frontend)
   */
  groupParents: kachemedia_specsheet_db.BookingGroup[];
  /**
   * Publications that can be chosen (unpacked from QueryBookingsSuccess.publications on frontend)
   */
  validPublications: common_db.WithDbId<kachemedia_specsheet_db.Publication>[];
  /**
   * Publications that have been selected by the user from the list of valid publications (unpacked
   * from QueryBookings.publications on frontend)
   */
  publications: common_db.WithDbId<kachemedia_specsheet_db.Publication>[];
  /**
   * Author - user of missing placement for linked with current booking
   */
  placementAuthorUserName: (common_strings.StringNE|null);
  /**
   * If author is from the same organisation as querying user - allow linked placement update
   */
  isPlacementEditable: boolean;
}

export function makeBookingView(
  input: {
    bookingDetails: common_db.WithDbId<kachemedia_specsheet_db.Booking>,
    publisher: common_db.WithDbId<kachemedia_specsheet_db.Publisher>,
    placement: common_db.WithDbId<kachemedia_specsheet_db.Placement>,
    groupParents?: kachemedia_specsheet_db.BookingGroup[],
    validPublications?: common_db.WithDbId<kachemedia_specsheet_db.Publication>[],
    publications?: common_db.WithDbId<kachemedia_specsheet_db.Publication>[],
    placementAuthorUserName?: (common_strings.StringNE|null),
    isPlacementEditable: boolean,
  }
): BookingView {
  return {
    bookingDetails: input.bookingDetails,
    publisher: input.publisher,
    placement: input.placement,
    groupParents: input.groupParents === undefined ? [] : input.groupParents,
    validPublications: input.validPublications === undefined ? [] : input.validPublications,
    publications: input.publications === undefined ? [] : input.publications,
    placementAuthorUserName: input.placementAuthorUserName === undefined ? null : input.placementAuthorUserName,
    isPlacementEditable: input.isPlacementEditable,
  };
}

const BookingView_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.campaigns","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"View of a placement from a campaign\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"bookingDetails","default":{"kind":"nothing"},"name":"bookingDetails","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Booking"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Publisher\n"}],"serializedName":"publisher","default":{"kind":"nothing"},"name":"publisher","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Publisher"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Placement\n"}],"serializedName":"placement","default":{"kind":"nothing"},"name":"placement","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Placement"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Values for parent groups (unpacked from QueryBookingsSuccess.bookingGroups on frontend)\n"}],"serializedName":"groupParents","default":{"kind":"just","value":[]},"name":"groupParents","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"BookingGroup"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Publications that can be chosen (unpacked from QueryBookingsSuccess.publications on frontend)\n"}],"serializedName":"validPublications","default":{"kind":"just","value":[]},"name":"validPublications","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Publication"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Publications that have been selected by the user from the list of valid publications (unpacked\nfrom QueryBookings.publications on frontend)\n"}],"serializedName":"publications","default":{"kind":"just","value":[]},"name":"publications","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Publication"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Author - user of missing placement for linked with current booking\n"}],"serializedName":"placementAuthorUserName","default":{"kind":"just","value":null},"name":"placementAuthorUserName","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"If author is from the same organisation as querying user - allow linked placement update\n"}],"serializedName":"isPlacementEditable","default":{"kind":"nothing"},"name":"isPlacementEditable","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"BookingView","version":{"kind":"nothing"}}};

export const snBookingView: ADL.ScopedName = {moduleName:"kachemedia.specsheet.campaigns", name:"BookingView"};

export function texprBookingView(): ADL.ATypeExpr<BookingView> {
  return {value : {typeRef : {kind: "reference", value : snBookingView}, parameters : []}};
}

/**
 * View of a placement from a campaign
 */
export interface BookingGroupView {
  bookingGroup: kachemedia_specsheet_db.BookingGroup;
  /**
   * Values for parent groups (unpacked from QueryBookingsSuccess.bookingGroups on frontend)
   */
  groupParents: kachemedia_specsheet_db.BookingGroup[];
}

export function makeBookingGroupView(
  input: {
    bookingGroup: kachemedia_specsheet_db.BookingGroup,
    groupParents?: kachemedia_specsheet_db.BookingGroup[],
  }
): BookingGroupView {
  return {
    bookingGroup: input.bookingGroup,
    groupParents: input.groupParents === undefined ? [] : input.groupParents,
  };
}

const BookingGroupView_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.campaigns","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"View of a placement from a campaign\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"bookingGroup","default":{"kind":"nothing"},"name":"bookingGroup","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"BookingGroup"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Values for parent groups (unpacked from QueryBookingsSuccess.bookingGroups on frontend)\n"}],"serializedName":"groupParents","default":{"kind":"just","value":[]},"name":"groupParents","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"BookingGroup"}},"parameters":[]}]}}]}},"name":"BookingGroupView","version":{"kind":"nothing"}}};

export const snBookingGroupView: ADL.ScopedName = {moduleName:"kachemedia.specsheet.campaigns", name:"BookingGroupView"};

export function texprBookingGroupView(): ADL.ATypeExpr<BookingGroupView> {
  return {value : {typeRef : {kind: "reference", value : snBookingGroupView}, parameters : []}};
}

export interface ExtCampaignClaimUnion_Qms {
  kind: 'qms';
  value: QmsCampaignClaim;
}
export interface ExtCampaignClaimUnion_Ooh {
  kind: 'ooh';
  value: OohCampaignClaim;
}

/**
 * Externally managed campaign claim
 */
export type ExtCampaignClaimUnion = ExtCampaignClaimUnion_Qms | ExtCampaignClaimUnion_Ooh;

export interface ExtCampaignClaimUnionOpts {
  /**
   * Campaign code and client from QMS media
   */
  qms: QmsCampaignClaim;
  /**
   * Campaign code and client from OOH media
   */
  ooh: OohCampaignClaim;
}

export function makeExtCampaignClaimUnion<K extends keyof ExtCampaignClaimUnionOpts>(kind: K, value: ExtCampaignClaimUnionOpts[K]) { return {kind, value}; }

const ExtCampaignClaimUnion_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.campaigns","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Externally managed campaign claim\n"}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Campaign code and client from QMS media\n"}],"serializedName":"qms","default":{"kind":"nothing"},"name":"qms","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.campaigns","name":"QmsCampaignClaim"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Campaign code and client from OOH media\n"}],"serializedName":"ooh","default":{"kind":"nothing"},"name":"ooh","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.campaigns","name":"OohCampaignClaim"}},"parameters":[]}}]}},"name":"ExtCampaignClaimUnion","version":{"kind":"nothing"}}};

export const snExtCampaignClaimUnion: ADL.ScopedName = {moduleName:"kachemedia.specsheet.campaigns", name:"ExtCampaignClaimUnion"};

export function texprExtCampaignClaimUnion(): ADL.ATypeExpr<ExtCampaignClaimUnion> {
  return {value : {typeRef : {kind: "reference", value : snExtCampaignClaimUnion}, parameters : []}};
}

/**
 * Campaign code and client from QMS media
 */
export interface QmsCampaignClaim {
  campaignCode: string;
  client: string;
}

export function makeQmsCampaignClaim(
  input: {
    campaignCode: string,
    client: string,
  }
): QmsCampaignClaim {
  return {
    campaignCode: input.campaignCode,
    client: input.client,
  };
}

const QmsCampaignClaim_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.campaigns","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Campaign code and client from QMS media\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"campaignCode","default":{"kind":"nothing"},"name":"campaignCode","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"client","default":{"kind":"nothing"},"name":"client","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"QmsCampaignClaim","version":{"kind":"nothing"}}};

export const snQmsCampaignClaim: ADL.ScopedName = {moduleName:"kachemedia.specsheet.campaigns", name:"QmsCampaignClaim"};

export function texprQmsCampaignClaim(): ADL.ATypeExpr<QmsCampaignClaim> {
  return {value : {typeRef : {kind: "reference", value : snQmsCampaignClaim}, parameters : []}};
}

/**
 * Campaign code and client from OOH media
 */
export interface OohCampaignClaim {
  campaignCode: string;
  client: string;
}

export function makeOohCampaignClaim(
  input: {
    campaignCode: string,
    client: string,
  }
): OohCampaignClaim {
  return {
    campaignCode: input.campaignCode,
    client: input.client,
  };
}

const OohCampaignClaim_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.campaigns","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Campaign code and client from OOH media\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"campaignCode","default":{"kind":"nothing"},"name":"campaignCode","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"client","default":{"kind":"nothing"},"name":"client","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"OohCampaignClaim","version":{"kind":"nothing"}}};

export const snOohCampaignClaim: ADL.ScopedName = {moduleName:"kachemedia.specsheet.campaigns", name:"OohCampaignClaim"};

export function texprOohCampaignClaim(): ADL.ATypeExpr<OohCampaignClaim> {
  return {value : {typeRef : {kind: "reference", value : snOohCampaignClaim}, parameters : []}};
}

export interface CampaignViewModel {
  campaign: CampaignView;
  campaignVersionInfo: CampaignVersionInfo;
  lastPublishedCampaignVersion: (CampaignVersionInfo|null);
  bookings: BookingView[];
  groups: BookingGroupView[];
  changesSummary: CampaignChangesSummary;
  campaignSubscribers: string[];
}

export function makeCampaignViewModel(
  input: {
    campaign: CampaignView,
    campaignVersionInfo: CampaignVersionInfo,
    lastPublishedCampaignVersion: (CampaignVersionInfo|null),
    bookings: BookingView[],
    groups: BookingGroupView[],
    changesSummary: CampaignChangesSummary,
    campaignSubscribers: string[],
  }
): CampaignViewModel {
  return {
    campaign: input.campaign,
    campaignVersionInfo: input.campaignVersionInfo,
    lastPublishedCampaignVersion: input.lastPublishedCampaignVersion,
    bookings: input.bookings,
    groups: input.groups,
    changesSummary: input.changesSummary,
    campaignSubscribers: input.campaignSubscribers,
  };
}

const CampaignViewModel_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.campaigns","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"campaign","default":{"kind":"nothing"},"name":"campaign","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.campaigns","name":"CampaignView"}},"parameters":[]}},{"annotations":[],"serializedName":"campaignVersionInfo","default":{"kind":"nothing"},"name":"campaignVersionInfo","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.campaigns","name":"CampaignVersionInfo"}},"parameters":[]}},{"annotations":[],"serializedName":"lastPublishedCampaignVersion","default":{"kind":"nothing"},"name":"lastPublishedCampaignVersion","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.campaigns","name":"CampaignVersionInfo"}},"parameters":[]}]}},{"annotations":[],"serializedName":"bookings","default":{"kind":"nothing"},"name":"bookings","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.campaigns","name":"BookingView"}},"parameters":[]}]}},{"annotations":[],"serializedName":"groups","default":{"kind":"nothing"},"name":"groups","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.campaigns","name":"BookingGroupView"}},"parameters":[]}]}},{"annotations":[],"serializedName":"changesSummary","default":{"kind":"nothing"},"name":"changesSummary","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.campaigns","name":"CampaignChangesSummary"}},"parameters":[]}},{"annotations":[],"serializedName":"campaignSubscribers","default":{"kind":"nothing"},"name":"campaignSubscribers","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"CampaignViewModel","version":{"kind":"nothing"}}};

export const snCampaignViewModel: ADL.ScopedName = {moduleName:"kachemedia.specsheet.campaigns", name:"CampaignViewModel"};

export function texprCampaignViewModel(): ADL.ATypeExpr<CampaignViewModel> {
  return {value : {typeRef : {kind: "reference", value : snCampaignViewModel}, parameters : []}};
}

/**
 * Describes the changes within a campaign version.
 * Constructed identically to the email content of the
 * campaign version changes email.
 */
export interface CampaignChangesSummary {
  /**
   * Information about bookings that were added.
   */
  bookingsAdded: BookingChangeView[];
  /**
   * Information about bookings that were removed.
   */
  bookingsRemoved: BookingChangeView[];
  /**
   * Information about bookings that were updated.
   */
  bookingsUpdated: BookingFieldUpdateChangeView[];
  bookingsPublicationsUpdated: BookingPublicationChangeView[];
  campaignDetailsUpdated: CampaignDetailsChange[];
}

export function makeCampaignChangesSummary(
  input: {
    bookingsAdded: BookingChangeView[],
    bookingsRemoved: BookingChangeView[],
    bookingsUpdated: BookingFieldUpdateChangeView[],
    bookingsPublicationsUpdated: BookingPublicationChangeView[],
    campaignDetailsUpdated: CampaignDetailsChange[],
  }
): CampaignChangesSummary {
  return {
    bookingsAdded: input.bookingsAdded,
    bookingsRemoved: input.bookingsRemoved,
    bookingsUpdated: input.bookingsUpdated,
    bookingsPublicationsUpdated: input.bookingsPublicationsUpdated,
    campaignDetailsUpdated: input.campaignDetailsUpdated,
  };
}

const CampaignChangesSummary_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.campaigns","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Describes the changes within a campaign version.\nConstructed identically to the email content of the\ncampaign version changes email.\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Information about bookings that were added.\n"}],"serializedName":"bookingsAdded","default":{"kind":"nothing"},"name":"bookingsAdded","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.campaigns","name":"BookingChangeView"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Information about bookings that were removed.\n"}],"serializedName":"bookingsRemoved","default":{"kind":"nothing"},"name":"bookingsRemoved","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.campaigns","name":"BookingChangeView"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Information about bookings that were updated.\n"}],"serializedName":"bookingsUpdated","default":{"kind":"nothing"},"name":"bookingsUpdated","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.campaigns","name":"BookingFieldUpdateChangeView"}},"parameters":[]}]}},{"annotations":[],"serializedName":"bookingsPublicationsUpdated","default":{"kind":"nothing"},"name":"bookingsPublicationsUpdated","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.campaigns","name":"BookingPublicationChangeView"}},"parameters":[]}]}},{"annotations":[],"serializedName":"campaignDetailsUpdated","default":{"kind":"nothing"},"name":"campaignDetailsUpdated","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.campaigns","name":"CampaignDetailsChange"}},"parameters":[]}]}}]}},"name":"CampaignChangesSummary","version":{"kind":"nothing"}}};

export const snCampaignChangesSummary: ADL.ScopedName = {moduleName:"kachemedia.specsheet.campaigns", name:"CampaignChangesSummary"};

export function texprCampaignChangesSummary(): ADL.ATypeExpr<CampaignChangesSummary> {
  return {value : {typeRef : {kind: "reference", value : snCampaignChangesSummary}, parameters : []}};
}

export interface BookingChangeView {
  /**
   * Booking ref of booking that was updated/created or removed.
   */
  bookingRef: kachemedia_specsheet_db.BookingRef;
  /**
   * A backend-generated user-friendly string describing booking that was changed.
   */
  description: common_strings.StringNE;
}

export function makeBookingChangeView(
  input: {
    bookingRef: kachemedia_specsheet_db.BookingRef,
    description: common_strings.StringNE,
  }
): BookingChangeView {
  return {
    bookingRef: input.bookingRef,
    description: input.description,
  };
}

const BookingChangeView_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.campaigns","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Booking ref of booking that was updated/created or removed.\n"}],"serializedName":"bookingRef","default":{"kind":"nothing"},"name":"bookingRef","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"BookingRef"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A backend-generated user-friendly string describing booking that was changed.\n"}],"serializedName":"description","default":{"kind":"nothing"},"name":"description","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"BookingChangeView","version":{"kind":"nothing"}}};

export const snBookingChangeView: ADL.ScopedName = {moduleName:"kachemedia.specsheet.campaigns", name:"BookingChangeView"};

export function texprBookingChangeView(): ADL.ATypeExpr<BookingChangeView> {
  return {value : {typeRef : {kind: "reference", value : snBookingChangeView}, parameters : []}};
}

export interface BookingPublicationChangeView {
  bookingRef: kachemedia_specsheet_db.BookingRef;
  description: common_strings.StringNE;
  valueBefore: common_strings.StringNE;
  valueAfter: common_strings.StringNE;
}

export function makeBookingPublicationChangeView(
  input: {
    bookingRef: kachemedia_specsheet_db.BookingRef,
    description: common_strings.StringNE,
    valueBefore: common_strings.StringNE,
    valueAfter: common_strings.StringNE,
  }
): BookingPublicationChangeView {
  return {
    bookingRef: input.bookingRef,
    description: input.description,
    valueBefore: input.valueBefore,
    valueAfter: input.valueAfter,
  };
}

const BookingPublicationChangeView_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.campaigns","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"bookingRef","default":{"kind":"nothing"},"name":"bookingRef","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"BookingRef"}},"parameters":[]}},{"annotations":[],"serializedName":"description","default":{"kind":"nothing"},"name":"description","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"valueBefore","default":{"kind":"nothing"},"name":"valueBefore","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"valueAfter","default":{"kind":"nothing"},"name":"valueAfter","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"BookingPublicationChangeView","version":{"kind":"nothing"}}};

export const snBookingPublicationChangeView: ADL.ScopedName = {moduleName:"kachemedia.specsheet.campaigns", name:"BookingPublicationChangeView"};

export function texprBookingPublicationChangeView(): ADL.ATypeExpr<BookingPublicationChangeView> {
  return {value : {typeRef : {kind: "reference", value : snBookingPublicationChangeView}, parameters : []}};
}

export interface BookingFieldUpdateChangeView {
  bookingRef: kachemedia_specsheet_db.BookingRef;
  description: common_strings.StringNE;
  changes: BookingFieldChange[];
}

export function makeBookingFieldUpdateChangeView(
  input: {
    bookingRef: kachemedia_specsheet_db.BookingRef,
    description: common_strings.StringNE,
    changes: BookingFieldChange[],
  }
): BookingFieldUpdateChangeView {
  return {
    bookingRef: input.bookingRef,
    description: input.description,
    changes: input.changes,
  };
}

const BookingFieldUpdateChangeView_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.campaigns","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"bookingRef","default":{"kind":"nothing"},"name":"bookingRef","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"BookingRef"}},"parameters":[]}},{"annotations":[],"serializedName":"description","default":{"kind":"nothing"},"name":"description","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"changes","default":{"kind":"nothing"},"name":"changes","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.campaigns","name":"BookingFieldChange"}},"parameters":[]}]}}]}},"name":"BookingFieldUpdateChangeView","version":{"kind":"nothing"}}};

export const snBookingFieldUpdateChangeView: ADL.ScopedName = {moduleName:"kachemedia.specsheet.campaigns", name:"BookingFieldUpdateChangeView"};

export function texprBookingFieldUpdateChangeView(): ADL.ATypeExpr<BookingFieldUpdateChangeView> {
  return {value : {typeRef : {kind: "reference", value : snBookingFieldUpdateChangeView}, parameters : []}};
}

export interface BookingFieldChange {
  fieldName: common_strings.StringNE;
  valueBefore: common_strings.StringNE;
  valueAfter: common_strings.StringNE;
}

export function makeBookingFieldChange(
  input: {
    fieldName: common_strings.StringNE,
    valueBefore: common_strings.StringNE,
    valueAfter: common_strings.StringNE,
  }
): BookingFieldChange {
  return {
    fieldName: input.fieldName,
    valueBefore: input.valueBefore,
    valueAfter: input.valueAfter,
  };
}

const BookingFieldChange_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.campaigns","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"fieldName","default":{"kind":"nothing"},"name":"fieldName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"valueBefore","default":{"kind":"nothing"},"name":"valueBefore","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"valueAfter","default":{"kind":"nothing"},"name":"valueAfter","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"BookingFieldChange","version":{"kind":"nothing"}}};

export const snBookingFieldChange: ADL.ScopedName = {moduleName:"kachemedia.specsheet.campaigns", name:"BookingFieldChange"};

export function texprBookingFieldChange(): ADL.ATypeExpr<BookingFieldChange> {
  return {value : {typeRef : {kind: "reference", value : snBookingFieldChange}, parameters : []}};
}

export interface CampaignDetailsChange_Title {
  kind: 'title';
  value: StringFieldValue;
}
export interface CampaignDetailsChange_LiveDate {
  kind: 'liveDate';
  value: StringFieldValue;
}
export interface CampaignDetailsChange_EndDate {
  kind: 'endDate';
  value: StringFieldValue;
}
export interface CampaignDetailsChange_Notes {
  kind: 'notes';
  value: WysiwygFieldValue;
}
export interface CampaignDetailsChange_Documents {
  kind: 'documents';
  value: UrlResourceFieldValue;
}

export type CampaignDetailsChange = CampaignDetailsChange_Title | CampaignDetailsChange_LiveDate | CampaignDetailsChange_EndDate | CampaignDetailsChange_Notes | CampaignDetailsChange_Documents;

export interface CampaignDetailsChangeOpts {
  title: StringFieldValue;
  liveDate: StringFieldValue;
  endDate: StringFieldValue;
  notes: WysiwygFieldValue;
  documents: UrlResourceFieldValue;
}

export function makeCampaignDetailsChange<K extends keyof CampaignDetailsChangeOpts>(kind: K, value: CampaignDetailsChangeOpts[K]) { return {kind, value}; }

const CampaignDetailsChange_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.campaigns","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"title","default":{"kind":"nothing"},"name":"title","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.campaigns","name":"StringFieldValue"}},"parameters":[]}},{"annotations":[],"serializedName":"liveDate","default":{"kind":"nothing"},"name":"liveDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.campaigns","name":"StringFieldValue"}},"parameters":[]}},{"annotations":[],"serializedName":"endDate","default":{"kind":"nothing"},"name":"endDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.campaigns","name":"StringFieldValue"}},"parameters":[]}},{"annotations":[],"serializedName":"notes","default":{"kind":"nothing"},"name":"notes","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.campaigns","name":"WysiwygFieldValue"}},"parameters":[]}},{"annotations":[],"serializedName":"documents","default":{"kind":"nothing"},"name":"documents","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.campaigns","name":"UrlResourceFieldValue"}},"parameters":[]}}]}},"name":"CampaignDetailsChange","version":{"kind":"nothing"}}};

export const snCampaignDetailsChange: ADL.ScopedName = {moduleName:"kachemedia.specsheet.campaigns", name:"CampaignDetailsChange"};

export function texprCampaignDetailsChange(): ADL.ATypeExpr<CampaignDetailsChange> {
  return {value : {typeRef : {kind: "reference", value : snCampaignDetailsChange}, parameters : []}};
}

export interface StringFieldValue {
  valueBefore: common_strings.StringNE;
  valueAfter: common_strings.StringNE;
}

export function makeStringFieldValue(
  input: {
    valueBefore: common_strings.StringNE,
    valueAfter: common_strings.StringNE,
  }
): StringFieldValue {
  return {
    valueBefore: input.valueBefore,
    valueAfter: input.valueAfter,
  };
}

const StringFieldValue_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.campaigns","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"valueBefore","default":{"kind":"nothing"},"name":"valueBefore","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"valueAfter","default":{"kind":"nothing"},"name":"valueAfter","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"StringFieldValue","version":{"kind":"nothing"}}};

export const snStringFieldValue: ADL.ScopedName = {moduleName:"kachemedia.specsheet.campaigns", name:"StringFieldValue"};

export function texprStringFieldValue(): ADL.ATypeExpr<StringFieldValue> {
  return {value : {typeRef : {kind: "reference", value : snStringFieldValue}, parameters : []}};
}

export interface WysiwygFieldValue {
  valueBefore: kachemedia_specsheet_common.WysiwygDescendant[];
  valueAfter: kachemedia_specsheet_common.WysiwygDescendant[];
}

export function makeWysiwygFieldValue(
  input: {
    valueBefore: kachemedia_specsheet_common.WysiwygDescendant[],
    valueAfter: kachemedia_specsheet_common.WysiwygDescendant[],
  }
): WysiwygFieldValue {
  return {
    valueBefore: input.valueBefore,
    valueAfter: input.valueAfter,
  };
}

const WysiwygFieldValue_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.campaigns","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"valueBefore","default":{"kind":"nothing"},"name":"valueBefore","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.common","name":"WysiwygDescendant"}},"parameters":[]}]}},{"annotations":[],"serializedName":"valueAfter","default":{"kind":"nothing"},"name":"valueAfter","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.common","name":"WysiwygDescendant"}},"parameters":[]}]}}]}},"name":"WysiwygFieldValue","version":{"kind":"nothing"}}};

export const snWysiwygFieldValue: ADL.ScopedName = {moduleName:"kachemedia.specsheet.campaigns", name:"WysiwygFieldValue"};

export function texprWysiwygFieldValue(): ADL.ATypeExpr<WysiwygFieldValue> {
  return {value : {typeRef : {kind: "reference", value : snWysiwygFieldValue}, parameters : []}};
}

export interface UrlResourceFieldValue {
  valueBefore: kachemedia_specsheet_common.UrlResource[];
  valueAfter: kachemedia_specsheet_common.UrlResource[];
}

export function makeUrlResourceFieldValue(
  input: {
    valueBefore: kachemedia_specsheet_common.UrlResource[],
    valueAfter: kachemedia_specsheet_common.UrlResource[],
  }
): UrlResourceFieldValue {
  return {
    valueBefore: input.valueBefore,
    valueAfter: input.valueAfter,
  };
}

const UrlResourceFieldValue_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.campaigns","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"valueBefore","default":{"kind":"nothing"},"name":"valueBefore","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.common","name":"UrlResource"}},"parameters":[]}]}},{"annotations":[],"serializedName":"valueAfter","default":{"kind":"nothing"},"name":"valueAfter","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.common","name":"UrlResource"}},"parameters":[]}]}}]}},"name":"UrlResourceFieldValue","version":{"kind":"nothing"}}};

export const snUrlResourceFieldValue: ADL.ScopedName = {moduleName:"kachemedia.specsheet.campaigns", name:"UrlResourceFieldValue"};

export function texprUrlResourceFieldValue(): ADL.ATypeExpr<UrlResourceFieldValue> {
  return {value : {typeRef : {kind: "reference", value : snUrlResourceFieldValue}, parameters : []}};
}

export interface MoveCampaignToNewWorkspaceReq {
  campaignId: common_db.DbKey<kachemedia_specsheet_db.Campaign>;
  newWorkspaceId: common_db.DbKey<kachemedia_specsheet_db.Workspace>;
}

export function makeMoveCampaignToNewWorkspaceReq(
  input: {
    campaignId: common_db.DbKey<kachemedia_specsheet_db.Campaign>,
    newWorkspaceId: common_db.DbKey<kachemedia_specsheet_db.Workspace>,
  }
): MoveCampaignToNewWorkspaceReq {
  return {
    campaignId: input.campaignId,
    newWorkspaceId: input.newWorkspaceId,
  };
}

const MoveCampaignToNewWorkspaceReq_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.campaigns","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"campaignId","default":{"kind":"nothing"},"name":"campaignId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Campaign"}},"parameters":[]}]}},{"annotations":[],"serializedName":"newWorkspaceId","default":{"kind":"nothing"},"name":"newWorkspaceId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Workspace"}},"parameters":[]}]}}]}},"name":"MoveCampaignToNewWorkspaceReq","version":{"kind":"nothing"}}};

export const snMoveCampaignToNewWorkspaceReq: ADL.ScopedName = {moduleName:"kachemedia.specsheet.campaigns", name:"MoveCampaignToNewWorkspaceReq"};

export function texprMoveCampaignToNewWorkspaceReq(): ADL.ATypeExpr<MoveCampaignToNewWorkspaceReq> {
  return {value : {typeRef : {kind: "reference", value : snMoveCampaignToNewWorkspaceReq}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "kachemedia.specsheet.campaigns.CampaignVersionInfo" : CampaignVersionInfo_AST,
  "kachemedia.specsheet.campaigns.CampaignView" : CampaignView_AST,
  "kachemedia.specsheet.campaigns.CampaignInfo" : CampaignInfo_AST,
  "kachemedia.specsheet.campaigns.CampaignFrontendStatus" : CampaignFrontendStatus_AST,
  "kachemedia.specsheet.campaigns.ClientView" : ClientView_AST,
  "kachemedia.specsheet.campaigns.PlacementView" : PlacementView_AST,
  "kachemedia.specsheet.campaigns.PlacementViewPartial" : PlacementViewPartial_AST,
  "kachemedia.specsheet.campaigns.BookingViewBasic" : BookingViewBasic_AST,
  "kachemedia.specsheet.campaigns.BookingView" : BookingView_AST,
  "kachemedia.specsheet.campaigns.BookingGroupView" : BookingGroupView_AST,
  "kachemedia.specsheet.campaigns.ExtCampaignClaimUnion" : ExtCampaignClaimUnion_AST,
  "kachemedia.specsheet.campaigns.QmsCampaignClaim" : QmsCampaignClaim_AST,
  "kachemedia.specsheet.campaigns.OohCampaignClaim" : OohCampaignClaim_AST,
  "kachemedia.specsheet.campaigns.CampaignViewModel" : CampaignViewModel_AST,
  "kachemedia.specsheet.campaigns.CampaignChangesSummary" : CampaignChangesSummary_AST,
  "kachemedia.specsheet.campaigns.BookingChangeView" : BookingChangeView_AST,
  "kachemedia.specsheet.campaigns.BookingPublicationChangeView" : BookingPublicationChangeView_AST,
  "kachemedia.specsheet.campaigns.BookingFieldUpdateChangeView" : BookingFieldUpdateChangeView_AST,
  "kachemedia.specsheet.campaigns.BookingFieldChange" : BookingFieldChange_AST,
  "kachemedia.specsheet.campaigns.CampaignDetailsChange" : CampaignDetailsChange_AST,
  "kachemedia.specsheet.campaigns.StringFieldValue" : StringFieldValue_AST,
  "kachemedia.specsheet.campaigns.WysiwygFieldValue" : WysiwygFieldValue_AST,
  "kachemedia.specsheet.campaigns.UrlResourceFieldValue" : UrlResourceFieldValue_AST,
  "kachemedia.specsheet.campaigns.MoveCampaignToNewWorkspaceReq" : MoveCampaignToNewWorkspaceReq_AST
};
